const Vue = require('vue')

const htmlTemplate = require('templates/buildings/info.html')

const { client } = require('sci/helpers')

const vueChaos = require('sci/helpers/vue-chaos')

const { randstr } = require('sci/utils')

const buildModal = ($el) => {
    $el.find('.show-location-info').click(function () {
        const state = $(this).data('state') || 1
        if (state === 1) {
            $el.find('.hidden-location-info').show()

            $(this).find('.location-is-hidden').hide()
            $(this).find('.location-is-shown').show()

            $(this).data('state', 2)
        } else if (state === 2) {
            $el.find('.hidden-location-info').hide()

            $(this).find('.location-is-hidden').show()
            $(this).find('.location-is-shown').hide()

            $(this).data('state', 1)
        }
    })

    $el.find('.nav-tabs').tab()

    $el.modal().on('hidden.bs.modal', function () {
        $el.remove()
    })
}

const buildVm = (data, buildingId, onNavigate) => {
    const id = 'modal-' + randstr()
    const tpl = $(htmlTemplate)
    tpl.attr('id', id)
    $('body').append(tpl)
    const $tpl = $(`#${id}`).modal()

    $tpl.modal().on('hidden.bs.modal', function () {
        $tpl.remove()
    })

    new Vue({
        el: `#${id}`,
        data: {
            buildingId,
            info: data,
            ui: {
                loading: false,
                showAddress: false
            }
        },
        ready () {
            if (!this.info) {
                this.load()
            } else {
                $tpl.find('.carousel').carousel()
            }
        },
        methods: {
            onNavigate (id) {
                onNavigate(id)
            },
            load () {
                $tpl.find('.carousel').carousel('destroy')
                this.ui.loading = true
                client
                    .background()
                    .get('Carregando imóvel...', `buildings/${buildingId}`)
                    .then(vueChaos($tpl))
                    .then((data) => {
                        this.ui.loading = false
                        this.info = data
                        Vue.nextTick(() => $tpl.find('.carousel').carousel())
                        // let $newEl = $(template({...response.data, loading: false}));
                        // buildModal($newEl);
                    })
            },
            showAddress () {
                this.ui.showAddress = !this.ui.showAddress
            }
        },
        computed: {
            hasOnNavigate () {
                return !!onNavigate
            }
        }
    })
}

Vue.directive('building-info', {
    params: ['id', 'data', 'on-navigate'],
    bind: function () {
        $(this.el).click(() => {
            buildVm(this.params.data, this.params.id, this.params.onNavigate)
        })
    }
    // $(this.el).click(() => {
    //     if (this.params.data) {
    //         let $el = $(template({...this.params.data, loading: false}));
    //         buildModal($el);
    //         return false;
    //     } else {
    //         let $el = $(template({loading: true}));
    //         buildModal($el);
    //         client
    //             .background()
    //             .get("Carregando imóvel...", `properties/view/${this.params.id}`)
    //             .then((response) => {
    //                 $el.modal('hide');
    //                 let $newEl = $(template({...response.data, loading: false}));
    //                 buildModal($newEl);
    //             });
    //     }
    // });
})

Vue.component('building-info-handler', {
    data: () => ({
        buildingId: null,
        buildingData: null
    }),
    props: {
        onNavigate: {
            type: Function
        }
    },
    methods: {
        showById (buildingId) {
            this.buildingId = buildingId
            this.buildingData = null

            Vue.nextTick(() => $(this.$els.fakeLink).click())
        },
        showByData (data) {
            this.buildingId = null
            this.buildingData = data

            Vue.nextTick(() => $(this.$els.fakeLink).click())
        }
    },
    template: `
<div>
    <a href="javascript:;" v-el:fake-link v-building-info :data="buildingData" :id="buildingId" :on-navigate="onNavigate"></a>
</div>
`
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/building-info.js